export default function($) {
  var $nav = $('#js-quick-nav')

  if (!$nav.length) {
    return
  }

  // Make nav sticky
  var sticky = new Waypoint.Sticky({
    element: $nav
  })

  // Create one waypoint for every section
  var waypoints = $('.quick-nav-section').waypoint({
    handler: function(direction) {
      // Highlight nav button corresponding to the current waypoint
      $('.quick-nav-link-current').removeClass('quick-nav-link-current')

      var anchor_id

      if (direction === 'up') {
        if (this.previous() !== null) {
          anchor_id = this.previous().element.id
        }
      } else {
        if (this.element !== null) {
          anchor_id = this.element.id
        }
      }

      $("a[href='#" + anchor_id + "']").addClass('quick-nav-link-current')
    },
    offset: 57, // Sticky nav height
    continuous: false
  })
}
